import { LOGIN_REQUEST, LOGIN_SUCCESS, LOGIN_FAILURE, SIGNUP_REQUEST, SIGNUP_SUCCESS, SIGNUP_FAILURE, CLEAR_AUTH_ERROR, FORGOT_PASSWORD_REQUEST, FORGOT_PASSWORD_SUCCESS, FORGOT_PASSWORD_FAILURE, RESET_PASSWORD_REQUEST, RESET_PASSWORD_SUCCESS, RESET_PASSWORD_FAILURE, CHANGE_PASSWORD_REQUEST, CHANGE_PASSWORD_SUCCESS, CHANGE_PASSWORD_FAILURE } from '../actions/authActions';
import { AUTH_LOGOUT, AUTH_VALIDATE_SUCCESS, TOKEN_LOGIN_REQUEST, TOKEN_LOGIN_SUCCESS, TOKEN_LOGIN_FAILURE } from '../actions/validateAction';

const initialState = {
  token: localStorage.getItem('token') || null,
  user: null,
  userpackageinfos: null,
  loading: false,
  error: null,
  signupResponse: null,
  tokenLoginLoading: false,
  tokenLoginError: null,
  forgotPasswordLoading: false,
  forgotPasswordError: null,
  forgotPasswordResponse: null,
  resetPasswordLoading: false,
  resetPasswordError: null,
  resetPasswordResponse: null,
  changePasswordLoading: false,
  changePasswordError: null,
  changePasswordResponse: null,
};

export default function authReducer(state = initialState, action) {
  switch (action.type) {
    case LOGIN_REQUEST:
    case SIGNUP_REQUEST:
      return { ...state, loading: true, error: null };
    case FORGOT_PASSWORD_REQUEST:
      return { ...state, forgotPasswordLoading: true, forgotPasswordError: null };
    case RESET_PASSWORD_REQUEST:
      return { ...state, resetPasswordLoading: true, resetPasswordError: null };
    case CHANGE_PASSWORD_REQUEST:
      return { ...state, changePasswordLoading: true, changePasswordError: null };
    case LOGIN_SUCCESS:
      return { ...state, loading: false, token: action.payload?.token || null };
    case AUTH_VALIDATE_SUCCESS:
      return {
        ...state,
        user: action.payload?.user || null,
        userpackageinfos: action.payload?.userpackageinfos || null,
        token: action.payload?.token || state.token,
      };
    case SIGNUP_SUCCESS:
      return { ...state, loading: false, signupResponse: action.payload };
    case FORGOT_PASSWORD_SUCCESS:
      return { ...state, forgotPasswordLoading: false, forgotPasswordResponse: action.payload };
    case RESET_PASSWORD_SUCCESS:
      return { ...state, resetPasswordLoading: false, resetPasswordResponse: action.payload };
    case CHANGE_PASSWORD_SUCCESS:
      return { ...state, changePasswordLoading: false, changePasswordResponse: action.payload };
    case LOGIN_FAILURE:
    case SIGNUP_FAILURE:
      return { ...state, loading: false, error: action.error };
    case FORGOT_PASSWORD_FAILURE:
      return { ...state, forgotPasswordLoading: false, forgotPasswordError: action.error };
    case RESET_PASSWORD_FAILURE:
      return { ...state, resetPasswordLoading: false, resetPasswordError: action.error };
    case CHANGE_PASSWORD_FAILURE:
      return { ...state, changePasswordLoading: false, changePasswordError: action.error };
    case CLEAR_AUTH_ERROR:
      return { ...state, error: null };
    case AUTH_LOGOUT:
      return { ...state, token: null, user: null, userpackageinfos: null };
    case TOKEN_LOGIN_REQUEST:
      return { ...state, tokenLoginLoading: true, tokenLoginError: null };
    case TOKEN_LOGIN_SUCCESS:
      return {
        ...state,
        tokenLoginLoading: false,
        token: action.payload?.token || null,
        user: action.payload?.user || null,
        userpackageinfos: action.payload?.userpackageinfos || null,
        tokenLoginError: null,
      };
    case TOKEN_LOGIN_FAILURE:
      return {
        ...state,
        tokenLoginLoading: false,
        tokenLoginError: action.error,
        token: null,
        user: null,
        userpackageinfos: null,
      };
    default:
      return state;
  }
}
